import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/us-stock/[symbol]/UsStockDetailClient.tsx");
